import { HttpClient } from "@angular/common/http";
import { Injectable } from "@angular/core";
import { AppFilter } from "../../../models/app-filter.model";
import { Zona } from "../../../models/zona";
import { AbPerfilAcesso } from "app/abstract/full-pages/perfil-acesso/perfil-acesso.abstract";

@Injectable({ providedIn: 'root' })
export class PerfilAcessoService extends AbPerfilAcesso {
    prefixo = "perfil_acessos";

    constructor(httpClient: HttpClient) {
        super(httpClient);
    }

    public desativar(id: number) {
        return this.delete(`${this.prefixo}/desativar/`, id);
    }

    public getAllPerfilAcessos(filter: AppFilter) {
        return this.get(`${this.prefixo}/filter/${filter.encode()}`);
    }

    public saveUpdatePerfilAcesso(obj: Zona) {
        return this.save(`${this.prefixo}/`, obj);
    }

    public getPerfilAcesso(id: number) {
        return this.get(`${this.prefixo}/`, id);
    }

    public getAllPerfilAcessosAtivos() {
        return this.get(`${this.prefixo}/all/ativos`);
    }

    public getLimitePerfisCadastrados() {
        return this.get(`${this.prefixo}/limite_perfis`);
    }
}